// src/components/DashUserRow.jsx
import React from "react";
import PropTypes from "prop-types";
import usershimmer from "../../assets/images/usershimmer.png";
import { useNavigate } from "react-router-dom";

const DashUserRow = ({ user, rank, themeColor }) => {
  const themeColor1 = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();

  const imageUrl =
    user.image && user.image !== "none" ? user.image : usershimmer;
  const navigate = useNavigate();

  // Replace with your real "last active" timestamp field:
  const lastActiveTimestamp = user.last_login || user.updated || null;
  const lastActiveText = lastActiveTimestamp
    ? new Date(lastActiveTimestamp * 1000).toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "--";

  // Determine which field holds the real ID:
  const actualId = user.id || user._id || user.userId;

  return (
    <tr style={{ minHeight: 88 }}>
      {/* Rank Column */}
      <td
        style={{
          textAlign: "center",
          verticalAlign: "middle",
          fontWeight: "bold",
          color: themeColor, // <- theme color for rank
          width: 60,
        }}
      >
        {rank}
      </td>

      {/* User Image Column */}
      <td
        style={{
          textAlign: "center",
          verticalAlign: "middle",
          width: 100,
        }}
      >
        <img
          src={imageUrl}
          alt={user.username}
          style={{
            width: 64,
            height: 64,
            borderRadius: 16,
            objectFit: "cover",
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = usershimmer;
          }}
        />
      </td>

      {/* Username Column */}
      <td
        className="user-name"
        style={{
          textAlign: "left",
          verticalAlign: "middle",
          fontWeight: 500,
          borderRight: "none",
          minWidth: 200,
        }}
      >
        {user.username}
      </td>

      {/* Last Connected Column */}
      <td
        style={{
          verticalAlign: "middle",
          textAlign: "center",
          minWidth: 270,
          padding: 0,
          fontSize: 16,
          borderRight: "none",
          borderLeft: "none",
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            height: 64, // match image height
            gap: 8,
            justifyContent: "center",
          }}
        >
          <span
            style={{
              color: themeColor1, // <- theme color for "Last Connected:"
              fontWeight: 500,
              letterSpacing: "0.5px",
              fontSize: 14,
              whiteSpace: "nowrap",
              minWidth: 110,
              display: "inline-block",
            }}
          >
            Last Connected:
          </span>
          <span
            style={{
              color: "#b6bdc7",
              fontWeight: 600,
              marginLeft: 0,
              fontSize: 12,
              whiteSpace: "nowrap",
              minWidth: 140,
              display: "inline-block",
            }}
          >
            {lastActiveText}
          </span>
        </span>
      </td>

      {/* View Button Column */}
      <td
        style={{
          verticalAlign: "middle",
          textAlign: "center",
          minWidth: 110,
          padding: 0,
          borderLeft: "none",
        }}
      >
        <button
          className="btn btn-theme"
          style={{
            minWidth: 60,
            fontSize: 14,
            padding: "6px 20px",
            margin: "auto",
            display: "block",
          }}
          onClick={() => navigate(`/profile/${actualId}`)}
        >
          View
        </button>
      </td>
    </tr>
  );
};

DashUserRow.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
    image: PropTypes.string,
    lastActiveTimestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  rank: PropTypes.number.isRequired,
  themeColor: PropTypes.string.isRequired,
};

export default DashUserRow;
